import type { Routes } from '@angular/router';
import { defaultPageOptions } from 'src/app/core/models';
import { CustomRoute, ReuseStrategyType } from 'src/app/core/interfaces/custom-route.interface';

export const searchResultPageComponentRoutes: CustomRoute[] = [
  {
    path: 'search',
    loadComponent: () => import('./search-results-page.component').then((r) => r.AppSearchResultsPageComponent),
    data: {
      page: defaultPageOptions,
    },
    shouldReuse: ReuseStrategyType.never,
  },
];
